if (!customElements.get('quick-filters')) {
    class QuickFilters extends HTMLElement {
        labels = [];
        allBtn = null;
        connectedCallback() {
            this.labels = Array.from(this.querySelectorAll('label'));
            this.allBtn = this.querySelector('facet-remove a');
            this.setEventListeners();
        }
        disconnectedCallback() {
            this.removeEventListeners();
        }
        setEventListeners = () => {
            this.labels.forEach((label) => label.addEventListener('click', this.handleCheck));
            if (this.allBtn)
                this.allBtn.addEventListener('click', this.handleAll);
        };
        removeEventListeners = () => {
            this.labels.forEach((label) => label.removeEventListener('click', this.handleCheck));
            if (this.allBtn)
                this.allBtn.removeEventListener('click', this.handleAll);
        };
        handleCheck = (event) => {
            if (!event.isTrusted)
                return;
            const target = event.currentTarget;
            const input = target.querySelector('input');
            const previouslySelected = this.querySelector('label input:checked');
            if (!input)
                return;
            if (previouslySelected && input !== previouslySelected) {
                previouslySelected.checked = false;
                input.checked = true;
                const previousLabel = previouslySelected.closest('label');
                previousLabel?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
            else {
                input.checked = !input.checked;
            }
            if (this.allBtn)
                this.allBtn.classList.remove('active');
        };
        handleAll = () => {
            if (this.allBtn && !this.allBtn.classList.contains('active'))
                this.allBtn.classList.add('active');
        };
    }
    customElements.define('quick-filters', QuickFilters);
}
